import * as tslib_1 from "tslib";
import { ShadingMethodBase } from "./ShadingMethodBase";
/**
 * ShadowMethodBase provides an abstract base method for shadow map methods.
 */
var ShadowMethodBase = (function (_super) {
    tslib_1.__extends(ShadowMethodBase, _super);
    /**
     * Creates a new ShadowMethodBase object.
     * @param castingLight The light used to cast shadows.
     */
    function ShadowMethodBase(castingLight) {
        var _this = _super.call(this) || this;
        _this._epsilon = .02;
        _this._alpha = 1;
        castingLight.shadowsEnabled = true;
        _this._castingLight = castingLight;
        _this.iAddTexture(castingLight.shadowMapper.depthMap);
        return _this;
    }
    Object.defineProperty(ShadowMethodBase.prototype, "alpha", {
        /**
         * The "transparency" of the shadows. This allows making shadows less strong.
         */
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            this._alpha = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowMethodBase.prototype, "castingLight", {
        /**
         * The light casting the shadows.
         */
        get: function () {
            return this._castingLight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShadowMethodBase.prototype, "epsilon", {
        /**
         * A small value to counter floating point precision errors when comparing values in the shadow map with the
         * calculated depth value. Increase this if shadow banding occurs, decrease it if the shadow seems to be too detached.
         */
        get: function () {
            return this._epsilon;
        },
        set: function (value) {
            this._epsilon = value;
        },
        enumerable: true,
        configurable: true
    });
    return ShadowMethodBase;
}(ShadingMethodBase));
export { ShadowMethodBase };



// WEBPACK FOOTER //
// ../dist/lib/methods/ShadowMethodBase.js